// const bcrypt = require("bcryptjs");
import CryptoJs from 'crypto-js';



// const encrypt2 = (password) => {
//   // let salt = bcrypt.genSalt(5);
//   let hash = bcrypt.hashSync(password,10);
//   return hash;
// };
const encrypt = (password) => {
  let salt='aysfqfqynp';
  let pwd = CryptoJs.MD5(password+salt).toString();
  // let hash = bcrypt.hashSync(password,10);
  return pwd;
};



// const decrypt =(password, hash)=>{
//   return bcrypt.compareSync(password,hash);
// };


export default encrypt;

